/*
  © 2024 KondaSoft
  https://www.kondasoft.com
*/

class Navbar extends HTMLElement {
  constructor () {
    super()

    this.handleDropdownsBackdrop()
    this.handleHeaderReveal()
    this.adjustOffcanvasMenu()
  }

  adjustOffcanvasMenu () {
    const offcanvasMenu = document.querySelector('#offcanvas-menu')
    const navbarMobile = document.querySelector('#navbar-mobile')

    offcanvasMenu?.addEventListener('show.bs.offcanvas', () => {
      const navbarSpacing = document.querySelector('#navbar-mobile').getBoundingClientRect().bottom
      offcanvasMenu.style.height = `${window.innerHeight - navbarSpacing}px`

      navbarMobile.querySelector('.svg-icon-menu')?.classList.add('svg-icon-menu-close')
    })

    offcanvasMenu?.addEventListener('hide.bs.offcanvas', () => {
      navbarMobile.querySelector('.svg-icon-menu')?.classList.remove('svg-icon-menu-close')
    })
  }

  handleHeaderReveal () {
    const headerGroup = document.querySelector('#header-group')
    if (!headerGroup) return

    // Use hysteresis so the layout change caused by shrinking the sticky
    // header cannot immediately push scrollY back across the same threshold.
    const SHRINK_THRESHOLD = 48
    const EXPAND_THRESHOLD = 8
    let ticking = false

    const update = () => {
      const scrollY = window.scrollY
      const isShrunk = headerGroup.classList.contains('header-is-scrolled')

      if (!isShrunk && scrollY > SHRINK_THRESHOLD) {
        headerGroup.classList.add('header-is-scrolled')
      } else if (isShrunk && scrollY < EXPAND_THRESHOLD) {
        headerGroup.classList.remove('header-is-scrolled')
      }

      // The announcement bar stays collapsed while scrolled down and only
      // reappears near the top (matches tasacasport.com). Animation is
      // handled in sections.css.
      if (scrollY > SHRINK_THRESHOLD) {
        headerGroup.classList.add('announcement-is-hidden')
      } else if (scrollY <= EXPAND_THRESHOLD) {
        headerGroup.classList.remove('announcement-is-hidden')
      }

      ticking = false
    }

    window.addEventListener('scroll', () => {
      if (ticking) return
      ticking = true
      requestAnimationFrame(update)
    }, { passive: true })

    update()
  }

  handleDropdownsBackdrop () {
    this.querySelectorAll('#navbar-desktop .dropdown-toggle').forEach(dropdown => {
      dropdown.addEventListener('hidden.bs.dropdown', () => {
        if (!document.querySelector('#navbar-desktop .dropdown-toggle.show')) {
          document.body.classList.remove('navbar-dropdown-open')
        }
      })
      dropdown.addEventListener('show.bs.dropdown', () => {
        document.body.classList.add('navbar-dropdown-open')
      })
    })
  }
}
customElements.define('navbar-wrapper', Navbar)
